
import { Injectable } from "@angular/core";
import { ServiceProvider } from "./service.provider";
import { DMSBaseService } from "./dms.base.service";
import {userSignIn } from "app/models/Auth.model";
import { AssetsSearch, ItemPagination } from "app/modules/admin/apps/file-manager/file-manager.types";
import { Util } from "app/models/util";
import { isArray, method } from "lodash";
import { Observable } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class DocumentService extends DMSBaseService {
  constructor(public provider: ServiceProvider,
    public util: Util
    ) {
    super("/assets", provider);
  }

  public createFolder(data) {
    return this.save(data, `/folder`);
  }

  public createChildFolder(data, parentFolderId: string) {
    return this.save(data, `/folder/${parentFolderId}`);
  }

  public saveFolder(data) {
    if (data.id != null) return this.updateFolder(data);
    return this.createFolder(data);
  }

  public updateFolder(data) {
    return this.update(data, `/${data.id}`);
  }

  public createAsset(data,parentFolderId){
    if(parentFolderId!==undefined&&parentFolderId!==null){
      return this.createChildFolder(data,parentFolderId)
    }
    else
    return this.createFolder(data)
  }

  public getAssets(paging: ItemPagination,search:AssetsSearch) {
    let method='/search'
    if(paging){
       method = `${method}?page=${paging.page}&limit=${paging.size}`
    }
    return this.save(search,method)
  }

  public trash(ids:string[]) {
    return this.deleteWithBody(ids,'/trash')
  }

  public delete_multi(ids:string[]) {
    return this.deleteWithBody(ids,'/delete')
  }

  public signInUser(data: userSignIn) {
    return this.save(data, "/sign-in")
  }

  public openFile(fileId: string) {
    // let _service: DownloadFileService = new DownloadFileService('/api/matters', this.provider);
    // return this.downloadFile("/api/matters/file/download?path=" + encodeURIComponent(fileId), fileName);
    // return this.getRecord(`/file/` + fileId);
    return this.downloadGet(`/file/`+ encodeURIComponent(fileId));
  }

  restore(ids:string[]) {
    return this.deleteWithBody(ids,`/restore`)

  }

  public shared(data) {
    return this.save(data, `/access`)
  }

  public sharedExt(data){
    return this.save(data,`/access/external`)
  }

  getAccess(id){
    return this.getList(`/access/asset/${id}`)
  }

  updateExternal(data){
    return this.update(data, '/access/external');
  }

  updateAccess(data){
    return this.update(data, `/access`);
  }

  deleteAccess(id){
    return this.deleteRecord(`/access/${id}`);
  }

  getDocById(docId) {
    return this.getRecord(`/${docId}`)
  }

  getAssetsPath(id:string){
    return this.getRecord(`/navigation/folder/${id}`)
  }

  copyAsset(assetIds:string[],parentId:string){
    return this.save(assetIds,`/copy/parent/${parentId}`)
  }

  moveAsset(assetId:string|any[],parentId:string){
      const assetIds=isArray(assetId)?assetId:[assetId]
      return this.save(assetIds,`/move/parent/${parentId}`)
  }

  getAssetFullPath(assetId: string) {
    return new Observable(subscribe=>{
       this.getAssetsPath(assetId).then(res=>{
        let path=""
        const response=this.getData(res)
        response.map((loc,index:number)=>{

            // if(index==0){
            //     path+=loc.name
            // }
            // else path=`${path} / ${loc.name}`
        })
        subscribe.next(response)
       }).catch(error=>{
        subscribe.next("Location Load Failed")
       })
    })
  }
  
  getAssetsZip(assetIds:string[]){
    return this.downloadPost('/download',assetIds);
  }

  getFile(fileID:string){
    const payload={
      guid:fileID,
      password:null
    }
    return this.save(payload,`/generate/preview/file`)
  }

}
